import ShopifySetup from "@/components/shopify/ShopifySetup.vue";

require('./bootstrap');

import axios from 'axios';
import {onFulfilled, onRejected} from "./axiosSessionTimeoutHandler";

axios.interceptors.response.use(onFulfilled, onRejected);

import {createApp} from 'vue';
import {createStore} from 'vuex';
import moment from 'moment';
import VueApexCharts from 'vue3-apexcharts';
import Swal from 'sweetalert2';
import Notifications from '@kyvg/vue3-notification';
import SvgVue from 'svg-vue3';
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';
import {VueQueryPlugin} from "@tanstack/vue-query"

/* Dashboard */
import HomeDashboard from '../views/dashboard/HomeDashboard.vue';
import DashboardSharedComponent from '../views/dashboard/DashboardShared.vue';
import dashboard from './modules/dashboard/dashboard';

/* User */
import user from './modules/user/user.js';

/* Reports */
import reports from './modules/reports/reports';
import templates from './modules/reports/templates';
import report from './modules/reports/report';
import pages from './modules/reports/pages';
import widgets from './modules/reports/widgets';
import widgetModal from './modules/reports/widgetModal';
import reportModal from './modules/reports/reportModal';
import lookups from './modules/reports/lookups';
import reportSchedules from './modules/reports/reportSchedules';

import ReportsIndexComponent from '../views/reports/components/index/ReportsIndex.vue';
import ReportsBuilderComponent from '../views/reports/components/builder/ReportsBuilder.vue';
import ReportsExportPreview from '../views/reports/components/export/ExportPreview.vue';

/* Registration */
import RegistrationForm from '@/components/billing/register/RegistrationForm.vue';

/* Strategy Purchase */
import StrategyPurchaseForm from '@/components/strategy-purchase/StrategyPurchaseForm.vue';
import StrategyPurchaseSuccess from '@/components/strategy-purchase/StrategyPurchaseSuccess.vue';

/* Keywords */
import keywords from './modules/keywords/keywords';
import KeywordOverview from '../views/keywords/components/KeywordOverview.vue';
import UntrackedKeywordOverview from "./components/keyword/UntrackedKeywordOverview.vue";
import keywordIdeas from './modules/keywords/keywordIdeas';
import KeywordIdeasComponent from '../views/keywords/components/KeywordIdeas.vue';

/* Competition */
import competition from './modules/competition/competition';

/* Whitelabel */
import WhitelabelRegister from './components/whitelabel/WhitelabelRegister.vue';
import WhitelabelCustomDomain from './components/whitelabel/WhitelabelCustomDomain.vue';
import WhitelabelSeoAgentSettings from './components/whitelabel/WhitelabelSeoAgentSettings.vue';
import AgencyGrowthRegister from "./components/whitelabel/AgencyGrowthRegister.vue";

/* Registration */
import registration from "./modules/registration/module";

/* Hike Local */
import ListingManager from './components/gbp/listing/LisitingManager';
import GenerateReplyButton from './components/gbp/reviews/GenerateReplyButton.vue';
import businessProfile from "./modules/gbp/businessProfile";

/* Onboarding */
import OnboardingContainer from "./components/onboarding/OnboardingContainer";
import onboarding from "./modules/onboarding/onboarding";

import SitemapView from "./components/sitemap/SitemapView";

/* Sitemap */
import strategy from "./modules/strategy/strategy";

/* Whitelabel */
import whitelabel from "./modules/whitelabel/whitelabel";

/* Support */
import SupportTickets from "./components/support/SupportTickets.vue";

/* Agency marketplace website sharing */
import CustomerSharing from "./components/agencyMarketplace/CustomerSharing.vue";
import AgencyHelpPage from "./components/agencyMarketplace/pages/AgencyHelpPage.vue";
import agencyMarketplace from "./modules/agencyMarketplace/agencyMarketplace";

import blogGeneration from "./modules/content/blogGeneration";
import BlogContentModal from "./components/content/modals/BlogContentModal.vue";

import Ga3SunsetWarning from "./components/ga/modals/ga3SunsetWarning.vue";

import LabelDanger from "./components/global/labels/LabelDanger.vue";

import FailedPayment from "./components/billing/FailedPayment.vue";
import AddCard from "./components/billing/AddCard.vue";
import billing from "./modules/billing/billing";

import {axiosCatchHandler} from "./modules/sharedGlobal";

/* Onsite Optimizer */
import onsiteEditor from "./modules/onsiteEditor/onsiteEditor";
import OnsiteInstallationPage from "./components/onsiteEditor/pages/OnsiteInstallationPage.vue";
import OnsiteOptimizerSplashPage from "./components/onsiteEditor/pages/OnsiteOptimizerSplashPage.vue";
import onsiteEditorInstallation from "./modules/onsiteEditor/installation";
import OnsiteOptimiserManageChanges from "./components/admin/onsiteOptimiser/OnsiteOptimiserManageChanges.vue";

/* CRM */
import EditStripeId from "./components/admin/crm/EditStripeId.vue";
import WebsitePrice from "./components/admin/crm/WebsitePrice.vue";
import EditDiscountCode from "./components/admin/crm/EditDiscountCode.vue";
import EditPackagePages from "./components/admin/crm/EditPackagePages.vue";
import EditPackageBlogPosts from "./components/admin/crm/EditPackageBlogPosts.vue";
import EditTerminateDate from "./components/admin/crm/EditTerminateDate.vue";

/* Uberall */
import UberallSettings from "./components/admin/uberall/UberallSettings.vue";

/* Global */
import EditInput from "./components/global/inputs/EditInput.vue";

/* Settings */
import ApiManagement from "./components/settings/apiManagement/ApiManagement.vue";
import BillingOverview from "@/components/settings/billing/BillingOverview.vue";
import EmailSettings from "@/components/settings/notifications/EmailSettings.vue";

/* Shopify */
import ShopifyEntrypoint from "@/components/shopify/ShopifyEntrypoint.vue";
import ShopifySignup from "@/components/shopify/ShopifySignup.vue";

/* Embed */
import EmbedDashboard from "@/components/embed/EmbedDashboard.vue";

/* Cancellation */
import AgencyCancellation from './components/cancellation/agency/AgencyCancellation.vue';
import CancelFlow from './components/cancel-flow/CancelFlow.vue';
import CancelFlowConfirmed from './components/cancel-flow/CancelFlowConfirmed.vue';
import { initChurnkeyPaymentWall } from './services/churnkey-payment-wall';

/* Two factor */
import TwoFactorChallenge from './components/auth/TwoFactorChallenge.vue';
import TwoFactorSetup from './components/auth/TwoFactorSetup.vue';

/* Website */
import WebsiteOverview from "./components/website/WebsiteOverview.vue";
import AgencyAddWebsiteForm from "./components/website/AgencyAddWebsiteForm.vue";
import agencyWebsite from "./modules/website/agencyWebsite";
import CancellingWebsiteWarning from "./components/website/CancellingWebsiteWarning.vue";
import CompetitionOverview from "./components/competition/CompetitionOverview.vue";
import competitionV2 from "@/modules/competition/competition-v2";
import CompetitionCompare from "@/components/competition/CompetitionCompare.vue";
import AddWebsiteForm from "./components/website/single/AddWebsiteForm.vue";
import singleWebsite from "./modules/website/singleWebsite";
import AppsumoAddWebsiteForm from "./components/website/appsumo/AppsumoAddWebsiteForm.vue";
import appsumoWebsite from "./modules/website/appsumoWebsite";
import traffic from "./modules/reporting/traffic";
import DeleteWebsiteForm from "@/components/cancellation/package/DeleteWebsiteForm.vue";

/* Agency */
import agencyCancellation from "./modules/agency/agencyCancellation";
import * as Sentry from "@sentry/vue";
import {captureException} from "./errorHelper";
import ReportingOverview from "@/components/reporting/ReportingOverview.vue";

/* Backlinks */
import BacklinkOverview from "@/components/backlinks/BacklinkOverview.vue";
import backlinks from "@/modules/backlinks/backlinks";
import BacklinkHealthcheckOverview from "@/components/backlinks/healthcheck/BacklinkHealthcheckOverview.vue";
import backlinkHealthcheck from "@/modules/backlinks/backlink-healthcheck";
import BacklinkOpportunityOverview from "@/components/backlinks/opportunity/BacklinkOpportunityOverview.vue";
import backlinkOpportunity from "@/modules/backlinks/backlink-opportunity";
import AiAssistant from "@/components/ai-assistant/AiAssistant.vue";

/* Ai Onboarding */
import AiOnboardingForm from "@/components/ai-onboarding/AiOnboardingForm.vue";
import keywordSuggestions from "@/modules/ai-onboarding/keyword-suggestions";
import aiOnboarding from "@/modules/ai-onboarding/ai-onboarding";

/* Actions v2 */
import ActionOverview from "@/components/actions/ActionOverview.vue";
import HiddenActionOverview from "@/components/actions/HiddenActionOverview.vue";
import InspectPageActions from "@/components/actions/InspectPageActions.vue";
import actions from "@/modules/actions/actions";
import SettingsOverview from "@/components/actions/SettingsOverview.vue";
import ActionInspectOverview from "@/components/actions/ActionInspectOverview.vue";
import CreateActionForm from "@/components/actions/CreateActionForm.vue";

/* KIT */
import ApprovalCenter from "@/components/approval-center/ApprovalCenter.vue";
import ApprovalCenterSettings from "@/components/approval-center/ApprovalCenterSettings.vue";
import CreateWebsiteForm from "@/components/website/v2/CreateWebsiteForm.vue";
import KitWebsiteSettings from "@/components/kit/KitWebsiteSettings.vue";
import OnsiteOptimizerWebsiteSettings from "@/components/onsiteOptimizer/OnsiteOptimizerWebsiteSettings.vue";
import WebBotAuthSettings from "@/components/crawler/WebBotAuthSettings.vue";
import KitActivityLog from "@/components/kit-activity-log/KitActivityLog.vue";
import KitPagesOverview from "@/components/admin/kit/pages/KitPagesOverview.vue";
import KitPagesPage from '@/components/kit-settings/pages/KitPages.vue';
import AiBusinessProfilePage from '@/components/kit-settings/pages/AiBusinessProfile.vue';
import ToneOfVoicePage from '@/components/kit-settings/pages/ToneOfVoice.vue';

/** Testing */
import SocketsTest from "@/components/testing/SocketsTest.vue";

/* Toasts */
import ToastOverlay from "@/components/global-themed/toast/ToastOverlay.vue";

/* Content Strategy */
import ToneOfVoiceGuide from "@/components/content/ToneOfVoiceGuide.vue";

/* Organisations */
import SwapBillingPeriod from "@/components/organisations/SwapBillingPeriod.vue";

/* Local */
import CitationOverview from "@/components/citations/CitationOverview.vue";

import RetrySchedule from "@/components/report-schedule/RetrySchedule.vue";

/* Email Templates */
import EmailTemplateOverview from "@/components/email-templates/EmailTemplateOverview.vue";
import EmailTemplateEditOverview from "@/components/email-templates/EmailTemplateEditOverview.vue";

/* SEO Score */
import SeoScoreAnnotationOverview from "@/components/admin/seo-score-annotations/SeoScoreAnnotationOverview.vue";

/* Banners */
import BannerOverview from "@/components/admin/banners/BannerOverview.vue";
import BannerEdit from "@/components/admin/banners/BannerEdit.vue";
import BannerCarousel from "@/components/banners/BannerCarousel.vue";
import SeoScore from "@/components/seo-score/SeoScore.vue";

/* Tours */
import tours from "@/modules/tours/tours";
import ContactInfoModal from "@/components/organisations/ContactInfoModal.vue";
import RestoreWebsiteModal from "@/components/global/RestoreWebsiteModal.vue";

import ApiChangeLog from '@/components/admin/apiChangeLog/ApiChangeLog.vue';
import FeatureFlags from '@/components/admin/featureFlags/FeatureFlags.vue';
import PyCrawlDashboard from '@/components/admin/pycrawl/PyCrawlDashboard.vue';

/* Email Logs */
import EmailLogs from "@/components/email-logs/EmailLogs.vue";

/* Google */
import SelectAnalytics from "@/components/google/SelectAnalytics.vue";
import SelectConsole from "@/components/google/SelectConsole.vue";
import SelectBusiness from "@/components/google/SelectBusiness.vue";

const store = createStore({
  modules: {
    dashboard,
    user,
    reports,
    templates,
    report,
    pages,
    widgets,
    widgetModal,
    reportModal,
    lookups,
    reportSchedules,
    keywords,
    keywordIdeas,
    competition,
    businessProfile,
    registration,
    onboarding,
    strategy,
    whitelabel,
    agencyMarketplace,
    blogGeneration,
    billing,
    onsiteEditor,
    onsiteEditorInstallation,
    agencyWebsite,
    agencyCancellation,
    competitionV2,
    singleWebsite,
    appsumoWebsite,
    traffic,
    backlinks,
    backlinkHealthcheck,
    backlinkOpportunity,
    keywordSuggestions,
    actions,
    aiOnboarding,
    tours,
  },
});

const app = createApp({});

app.config.globalProperties.$axiosExceptionHandler = axiosCatchHandler;

app.use(store);
app.use(Notifications);
app.use(VueApexCharts);
app.use(SvgVue);
const vueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 24,
        retry: 0,
      }
    },
  },
  enableDevtoolsV6Plugin: true,
};
app.use(VueQueryPlugin, vueQueryPluginOptions);

/** Testing */
app.component('SocketsTest', SocketsTest);

app.component('ReportsIndex', ReportsIndexComponent);
app.component('ReportsBuilder', ReportsBuilderComponent);
app.component('ReportsExportPreview', ReportsExportPreview);
app.component('KeywordOverview', KeywordOverview);
app.component('KeywordIdeas', KeywordIdeasComponent);
app.component('HomeDashboard', HomeDashboard);
app.component('DashboardShared', DashboardSharedComponent);
app.component('ListingManager', ListingManager);
app.component('GenerateReplyButton', GenerateReplyButton);
app.component('WhitelabelRegister', WhitelabelRegister);
app.component('AgencyGrowthRegister', AgencyGrowthRegister);
app.component('OnboardingContainer', OnboardingContainer);
app.component('SitemapView', SitemapView);
app.component('SupportTickets', SupportTickets);
app.component('CustomerSharing', CustomerSharing);
app.component('AgencyHelpPage', AgencyHelpPage);
app.component('BlogContentModal', BlogContentModal);
app.component('LabelDanger', LabelDanger);
app.component('Ga3SunsetWarning', Ga3SunsetWarning);
app.component('FailedPayment', FailedPayment);
app.component('AddCard', AddCard);
app.component('OnsiteInstallationPage', OnsiteInstallationPage);
app.component('EditInput', EditInput);
app.component('EditStripeId', EditStripeId);
app.component('EditTerminateDate', EditTerminateDate);
app.component('WhitelabelCustomDomain', WhitelabelCustomDomain);
app.component('WhitelabelSeoAgentSettings', WhitelabelSeoAgentSettings);
app.component('WebsitePrice', WebsitePrice);
app.component('EditDiscountCode', EditDiscountCode);
app.component('EditPackagePages', EditPackagePages);
app.component('EditPackageBlogPosts', EditPackageBlogPosts);
app.component('UberallSettings', UberallSettings);
app.component('ApiManagement', ApiManagement);
app.component('TwoFactorChallenge', TwoFactorChallenge);
app.component('TwoFactorSetup', TwoFactorSetup);
app.component('WebsiteOverview', WebsiteOverview);
app.component('AgencyAddWebsiteForm', AgencyAddWebsiteForm);
app.component('UntrackedKeywordOverview', UntrackedKeywordOverview);
app.component('CancellingWebsiteWarning', CancellingWebsiteWarning);
app.component('OnsiteOptimizerSplashPage', OnsiteOptimizerSplashPage);
app.component('OnsiteOptimiserManageChanges', OnsiteOptimiserManageChanges);
app.component('CompetitionOverview', CompetitionOverview);
app.component('CompetitionCompare', CompetitionCompare);
app.component('AddWebsiteForm', AddWebsiteForm);
app.component('AppsumoAddWebsiteForm', AppsumoAddWebsiteForm);
app.component('AgencyCancellation', AgencyCancellation);
app.component('CancelFlow', CancelFlow);
app.component('CancelFlowConfirmed', CancelFlowConfirmed);
app.component('ReportingOverview', ReportingOverview);
app.component('BacklinkOverview', BacklinkOverview);
app.component('BacklinkHealthcheckOverview', BacklinkHealthcheckOverview);
app.component('BacklinkOpportunityOverview', BacklinkOpportunityOverview);
app.component('AiAssistant', AiAssistant);
app.component('AiOnboardingForm', AiOnboardingForm);
app.component('ActionOverview', ActionOverview);
app.component('HiddenActionOverview', HiddenActionOverview);
app.component('InspectPageActions', InspectPageActions);
app.component('SettingsOverview', SettingsOverview);
app.component('ActionInspectOverview', ActionInspectOverview);
app.component('ToastOverlay', ToastOverlay);
app.component('ToneOfVoiceGuide', ToneOfVoiceGuide);
app.component('ApprovalCenter', ApprovalCenter);
app.component('ApprovalCenterSettings', ApprovalCenterSettings);
app.component('CreateActionForm', CreateActionForm);
app.component('CreateWebsiteForm', CreateWebsiteForm);
app.component('KitWebsiteSettings', KitWebsiteSettings);
app.component('OnsiteOptimizerWebsiteSettings', OnsiteOptimizerWebsiteSettings);
app.component('WebBotAuthSettings', WebBotAuthSettings);
app.component('KitActivityLog', KitActivityLog);
app.component('KitPages', KitPagesPage);
app.component('AiBusinessProfile', AiBusinessProfilePage);
app.component('ToneOfVoice', ToneOfVoicePage);
app.component('RegistrationForm', RegistrationForm);
app.component('StrategyPurchaseForm', StrategyPurchaseForm);
app.component('StrategyPurchaseSuccess', StrategyPurchaseSuccess);
app.component('DeleteWebsiteForm', DeleteWebsiteForm);
app.component('KitPagesOverview', KitPagesOverview);
app.component('BillingOverview', BillingOverview);
app.component('EmailSettings', EmailSettings);
app.component('CitationOverview', CitationOverview);

app.component('EmailTemplateOverview', EmailTemplateOverview);
app.component('EmailTemplateEditOverview', EmailTemplateEditOverview);

app.component('SeoScoreAnnotationOverview', SeoScoreAnnotationOverview);

app.component('BannerOverview', BannerOverview);
app.component('BannerEdit', BannerEdit);
app.component('BannerCarousel', BannerCarousel);

app.component('ShopifyEntrypoint', ShopifyEntrypoint);
app.component('ShopifySignup', ShopifySignup);
app.component('ShopifySetup', ShopifySetup);

app.component('EmbedDashboard', EmbedDashboard);
app.component('RetrySchedule', RetrySchedule);

app.component('SwapBillingPeriod', SwapBillingPeriod);
app.component('ContactInfoModal', ContactInfoModal);
app.component('RestoreWebsiteModal', RestoreWebsiteModal);

app.component('ApiChangeLog', ApiChangeLog);
app.component('FeatureFlags', FeatureFlags);
app.component('PyCrawlDashboard', PyCrawlDashboard);
app.component('SeoScore', SeoScore);

app.component('EmailLogs', EmailLogs);

app.component('SelectAnalytics', SelectAnalytics);
app.component('SelectConsole', SelectConsole);
app.component('SelectBusiness', SelectBusiness);

app.config.globalProperties.SweetToast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  }
});

app.directive('titleCase', (el, binding) => {
  if (binding.value) {
    let titleCase = binding.value.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
    let removeUnderscores = titleCase.replace(/_/g, ' ');
    el.innerHTML = removeUnderscores;
  }

});

app.directive('date', (el, binding) => {
  if (moment(binding.value, 'YYYY-MM-DD').isValid()) {
    el.innerHTML = moment(binding.value, 'YYYY-MM-DD').format('DD/MM/YYYY');
  } else if (binding.value === '') {
    el.innerHTML = 'DD/MM/YYYY';
  } else {
    el.innerHTML = binding.value;
  }
});

app.directive('datetime', (el, binding) => {
  if (moment(binding.value, 'YYYY-MM-DD HH:mm').isValid()) {
    el.innerHTML = moment(binding.value, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY HH:mm');
  } else if (binding.value === '') {
    el.innerHTML = 'DD/MM/YYYY HH:mm';
  } else {
    el.innerHTML = binding.value ?? '-';
  }
});

app.use(FloatingVue, {
  disposeTimeout: 15000,
  themes: {
    'small-tooltip': {
      $extend: 'tooltip',
    },
    'large-tooltip': {
      $extend: 'tooltip',
    },
    'ose-tooltip': {
      $extend: 'tooltip',
    },
    'ose-large-tooltip': {
      $extend: 'ose-tooltip',
    },
    'large-ose-info-tooltip': {
      $extend: 'ose-tooltip',
    },
    'dark-blue-tooltip': {
      $extend: 'tooltip',
    },
    'primary-tooltip': {
      $extend: 'tooltip',
    },
    'default-tooltip': {
      $extend: 'tooltip',
    },
  },
});

app.use(VueApexCharts);

if (process.env.APP_ENV === 'production') {
  Sentry.init({
    dsn: process.env.MIX_SENTRY_DSN_PUBLIC,
    app,
    integrations: [
      Sentry.replayIntegration(),
    ],
    replaysSessionSampleRate: process.env.MIX_SENTRY_TRACES_SAMPLE_RATE ?? 0.1,
    replaysOnErrorSampleRate: process.env.MIX_SENTRY_ERROR_SAMPLE_RATE ?? 0.1,
  });
}

app.mount('#vue_container');

window.App = app;

initChurnkeyPaymentWall();
